import {Injectable} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {DeviceDetectorService} from 'ngx-device-detector';
import * as moment from "moment";

@Injectable({
    providedIn: 'root'
})

export class HelperService {
    
    constructor(public translate: TranslateService,
                private readonly deviceService: DeviceDetectorService) {
    }
    
    public getCountTime2Day() {
        const times = [];
        for (let i = 1; i <= 48; i++) {
            let value: any = i;
            value = value.toString();
            const time = {
                id: i,
                text: i + ' ' + this.translate.instant('modules.notify.notification.timeEffectTitle'),
            };
            times.push(time);
        }
        return times.reverse();
    }
    
    isIOS() {
        const deviceInfo = this.deviceService.getDeviceInfo();
        // @ts-ignore
        return /iPad|iPhone|iPod/.test(deviceInfo.userAgent) && !window.MSStream;
    }
    
    formatNumber(num: any): string {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }
    
    convertShareToPercent(str: string): string {
        const array = str.split("/");
        const value = (Number(array[0]) / Number(array[1]) * 100).toFixed(0) + '%';
        return String(value);
    }
    
    sortName(arrayToSort: any) {
        arrayToSort.sort((a: any, b: any) => {
            const nameA = this.deleteVietKey(a.name.toLowerCase());
            const nameB = this.deleteVietKey(b.name.toLowerCase());
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
    }
    
    deleteVietKey(str: string) {
        str = str.replace(/\s+/g, ' ');
        str = str.trim();
        str = str.replace(/[àáạảãâầấậẩẫăằắặẳẵ]/g, "a");
        str = str.replace(/[èéẹẻẽêềếệểễ]/g, "e");
        str = str.replace(/[ìíịỉĩ]/g, "i");
        str = str.replace(/[òóọỏõôồốộổỗơờớợởỡ]/g, "o");
        str = str.replace(/[ùúụủũưừứựửữ]/g, "u");
        str = str.replace(/[ỳýỵỷỹ]/g, "y");
        str = str.replace(/đ/g, "d");
        str = str.replace(/[ÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴ]/g, "A");
        str = str.replace(/[ÈÉẸẺẼÊỀẾỆỂỄ]/g, "E");
        str = str.replace(/[ÌÍỊỈĨ]/g, "I");
        str = str.replace(/[ÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠ]/g, "O");
        str = str.replace(/[ÙÚỤỦŨƯỪỨỰỬỮ]/g, "U");
        str = str.replace(/[ỲÝỴỶỸ]/g, "Y");
        str = str.replace(/Đ/g, "D");
        return str;
    }
    
    formatDateRange(start: string, end: string, lang: any) {
        const startDate = moment(start);
        const endDate = moment(end);
        if (startDate.isSame(endDate, 'day')) {
            if (lang === 'vi') {
                return `${startDate.format('DD/MM/YYYY')}`;
            } else {
                return `${startDate.format('MMM D, YYYY')}`;
            }
        } else if (startDate.year() !== endDate.year()) {
            if (lang === 'vi') {
                return `${startDate.format('DD/MM/YYYY')} - ${endDate.format('DD/MM/YYYY')}`;
            } else {
                return `${startDate.format('MMM D, YYYY')} – ${endDate.format('MMM D, YYYY')}`;
            }
        } else if (startDate.month() !== endDate.month()) {
            if (lang === 'vi') {
                return `${startDate.format('DD/MM')} - ${endDate.format('DD/MM')}, ${startDate.format('YYYY')}`;
            } else {
                return `${startDate.format('MMM D')} – ${endDate.format('MMM D, YYYY')}`;
            }
        } else {
            if (lang === 'vi') {
                return `${startDate.format('DD/MM')} - ${endDate.format('DD/MM')}, ${startDate.format('YYYY')}`;
            } else {
                return `${startDate.format('MMM D')} – ${endDate.format('D, YYYY')}`;
            }
        }
    }
    
    getStringThisWeek(start: string, end: string) {
        const startDate = moment(start);
        const endDate = moment(end);
        return `${startDate.format('DD/MM')} - ${endDate.format('DD/MM')}`;
    }
    
    formatNumberCpm(num: number) {
        if (num !== 0) {
            num = Number((num / 1000).toFixed(0));
        }
        return num;
    }
    
    customFilterMultiSelect(elementId: string, keyword: string) {
        $(`#${elementId} .multiselect-item`).each((index: number, option: any) => {
            const optionText = $(option).find('.form-check-label').text().toLowerCase();
            const normalizedOptionText = this.deleteVietKey(optionText);
            if (normalizedOptionText.includes(this.deleteVietKey(keyword.toLowerCase()))) {
                $(option).show();
                if (option.classList.contains('multiselect-filter-hidden')) {
                    option.classList.remove('multiselect-filter-hidden');
                }
            } else {
                $(option).hide();
            }
        });
    }
    
    customSelectAllMultiSelect2(elementId: string, type = 'number') {
        const value: (string | number | string[] | undefined)[] = [];
        $(`#${elementId} .multiselect-item`).each((index: number, option: any) => {
            if (!option.classList.contains('multiselect-filter-hidden')) {
                let val = $(option).find('.form-check-input').val();
                if (type === 'number' && val !== undefined) {
                    val = Number(val);
                }
                if (val !== undefined && val !== null) {
                    value.push(val);
                }
            }
        });
        return value;
    }
    
    htmlTagValidator(value: string) {
        return /<\/?[^>]+>/.test(value);
    }
    
    handleUrlRedirect(data: any) {
        const urlData = data ? data.split('?') : [];
        const path = urlData.length > 0 ? urlData[0] : '/';
        const queries = urlData.length > 1 ? urlData[1].split('&') : [];
        const queryParams: any = {};
        const keyParam: any[] = [];
        const valueParam: any[] = [];
        if (queries.length > 0) {
            for (const i in queries) {
                const str = queries[i].split('=');
                keyParam.push(str[0]);
                valueParam.push(str[1]);
            }
        }
        keyParam.forEach((key, i) => queryParams[key] = (valueParam)[i]);
        const url = path !== 'undefined' ? path : '/';
        return {
            url,
            queryParams
        }
    }
    
    convertDataHtml(encodedString: string): string {
        const textArea = document.createElement('textarea');
        textArea.innerHTML = encodedString;
        return textArea.value.replace(/<[^>]*>/g, '');
    }
}
